import { combineReducers } from "redux";
import invitation from "./invitation";
import questionnaire from "./questionnaire";

export default combineReducers({
    invitation,
    questionnaire
});
